import { render } from "./UserInfoComponent.vue?vue&type=template&id=5853fdd8&scoped=true"
import script from "./UserInfoComponent.vue?vue&type=script&lang=js"
export * from "./UserInfoComponent.vue?vue&type=script&lang=js"

import "./UserInfoComponent.vue?vue&type=style&index=0&id=5853fdd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5853fdd8"]])

export default __exports__